import type * as UserRequestModel from 'af-root/scenes/Authentication/formModel';

import { EMAIL_REGEX } from '@acceligentllc/shared/constants/regex';

export default function validate(values: UserRequestModel.PasswordForgotten) {
	const errors: UserRequestModel.PasswordForgotten = {} as UserRequestModel.PasswordForgotten;

	if (!values.email) {
		errors.email = 'Email required';
	} else if (!EMAIL_REGEX.test(values.email)) {
		errors.email = 'Invalid email address';
	}

	return errors;
}
